module.exports = __webpack_public_path__ + "img/appointment.867ef3d6.svg";